module.exports = __webpack_public_path__ + "img/dispositivos2.d77bd239.png";